import styled from "styled-components";

export const ValidationError = styled.div`
  color: red;
  margin-bottom: 10px;
`;